import * as qiniu from "qiniu-js";
import axios from "axios";
import { Log } from "@/utils/index.js";
import { SERVICE_URL } from "@/config.js";

/**
 * 上传文件
 * @param {*} file
 * @param {*} key
 * @param {*} token
 * @param {*} putExtra
 * @param {*} config
 */
const uploadFile = (key, file, currentProgress) =>
  new Promise((resolve, reject) => {
    const config = {
      useCdnDomain: true,
    };

    const putExtra = {
      fname: file.name,
    };

    getUploadToken().then((token) => {
      const observable = qiniu.upload(file, key, token, putExtra, config);

      observable.subscribe({
        // 接收上传进度信息的回调函数
        next(res) {
          const total = res.total;
          currentProgress.value = total.percent;
        },
        error(err) {
          Log.failure("Kodo uploadFile", err);
          reject(err);
        },
        complete(res) {
          Log.success("Kodo uploadFile", res);
          resolve(res);
        },
      });
    });
  });

/**
 * 获取上传凭证
 * @returns
 */
const getUploadToken = async () => {
  try {
    const url = `${SERVICE_URL}/kodo/upload_token`;

    const response = await axios.get(url);
    const data = response.data;
    Log.success("getUploadToken", data);

    return data.upload_token;
  } catch (error) {
    Log.failure("getUploadToken", error);
    throw error;
  }
};

/**
 *
 * @param {*} kodoKey
 * @returns
 */
const getCdnUrl = async (kodoKey) => {
  try {
    const url = `${SERVICE_URL}/kodo/object/${kodoKey}`;

    const response = await axios.get(url);
    const data = response.data;
    Log.success("getCdnUrl", data.download_url);

    return data.download_url;
  } catch (error) {
    Log.failure("getCdnUrl", error);
    throw error;
  }
};

export default { uploadFile, getCdnUrl };
